import { useHistory } from 'react-router-dom';

import { useLocalize } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import SettingsCollection, { ArchiveRestoreMutationTuple } from '../generic/SettingsCollection';

export default function GoalTemplateListContainer() {
	const history = useHistory();
	const { localize } = useLocalize();

	return (
		<SettingsCollection
			query={graphql.useGoalTemplatesQuery}
			lazyQuery={graphql.useGoalTemplatesLazyQuery}
			field="goalTemplates"
			translationKey="settings.goals"
			title={(template: graphql.GoalTemplate) => localize(template.title).text}
			link={(template) => `/settings/goals/templates/${template.id}`}
			variables={{}}
			archive={graphql.useArchiveGoalTemplateMutation() as unknown as ArchiveRestoreMutationTuple}
			restore={graphql.useRestoreGoalTemplateMutation() as unknown as ArchiveRestoreMutationTuple}
			onAdd={() => history.push('/settings/goals/templates/new')}
		/>
	);
}
